module.exports = __webpack_public_path__ + "img/OPEN_NEW_TAB.6a9d79a0.svg";